module.exports = __webpack_public_path__ + "img/icon_3_23.d4431de8.png";